var _rect, _polygon, _polygon2, _polygon3, _path, _polygon4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 0 24 24",
    width: "24px",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 24,
    width: 24
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "18.26 9.38 16.77 8.7 18.26 8.02 18.93 6.54 19.61 8.02 21.09 8.7 19.61 9.38 18.93 10.86 18.26 9.38",
    fill: "currentColor"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "19.61 4.8 18.57 4.32 19.61 3.85 20.08 2.81 20.56 3.85 21.6 4.32 20.56 4.8 20.08 5.84 19.61 4.8",
    fill: "currentColor"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "15.73 8.03 16.63 6.05 18.61 5.15 16.63 4.24 15.73 2.26 14.83 4.24 12.84 5.15 14.83 6.05 15.73 8.03",
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3,12.41c0,4.18-3.39,7.58-7.58,7.58s-7.58-3.39-7.58-7.58,3.39-7.58,7.58-7.58v-1.75C6.58,3.09,2.4,7.26,2.4,12.41s4.18,9.32,9.32,9.32,9.32-4.18,9.32-9.32h-1.75Z",
    fill: "currentColor"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "15.31 9.17 8.14 9.17 8.14 10.91 10.65 10.91 10.65 16.85 12.8 16.85 12.8 10.91 15.31 10.91 15.31 9.17",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIcon);
export default __webpack_public_path__ + "static/media/ai_icon.881eb43a7412401043cb8038906bcef6.svg";
export { ForwardRef as ReactComponent };